export default __webpack_public_path__ + "static/media/checkbox-checked@2x.b4eb9a6a.png";